import { useState } from 'react';
import Head from "next/head";
import Image from "next/image"
import { useRouter } from 'next/router';
import tnpscwebbanner from "../../assets/images/Tnpsc/TNPSC-Group-II-Mock-test-Web-Banner.jpg";
import tnpscmobbanner from "../../assets/images/Tnpsc/TNPSC-Group-II-Mock-test-Mobile-Banner.jpg";
import { NewStudentForm } from '../../components/Tnpsc-Paymentgateway/TnpscgroupImainsstd';
import Navbar from '../../components/Navbar/Navbar';
import NewiconA from "../../assets/images/header/pdf-download1.png";
import Footer from '../../components/Footer/Footer';
import styles from "../sch-test/delhi-prefit.module.css";
import Link from "next/link";

export default function MobileCheck() {
  const [mobile, setMobile] = useState('');
  const [studentType, setStudentType] = useState('check');
  const router = useRouter(); 
  const [isloading, setLoading] = useState(false);
  const [existingData, setExistingData] = useState(null);

  return (
    <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2026-01-08T05:43:44+00:00" />
            <title> TNPSC Group II/IIA Mains State Level Mock Test 2026</title>
            <meta name="title" content="TNPSC Group II/IIA Mains State Level Mock Test 2026" />
            <meta name="description" content="Register for TNPSC Group II/IIA Mains State Level Mock Test 2026. Get full syllabus coverage, state ranking, expert feedback & detailed analysis." />
            <meta name="keywords" content="TNPSC Group II/IIA Mains State Level Mock Test 2026, TNPSC Group I Mains State Level Mock Test, free test" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-II-IIA-mains-mock-test/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group II/IIA Mains State Level Mock Test 2026" />
            <meta property="og:description" content="Register for TNPSC Group II/IIA Mains State Level Mock Test 2026. Get full syllabus coverage, state ranking, expert feedback & detailed analysis." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-II-IIA-mains-mock-test/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

      <Navbar title="sch-test" />
      
       <div>
        <div className="container p-3">
         <h1 className={`${styles.contactheader} pt-2 `}>
            I'M TOP TNPSC Group II/IIA Mains State Level Mock Test 2026
          </h1>

           <div className='row pt-2 d-none d-md-block'>
            <div className='col'>
                <Image src={tnpscwebbanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test"/>
            </div>
        </div>
        <div className='row pt-2 d-block d-md-none'>
            <div className='col'>
              <Image src={tnpscmobbanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test"  />
            </div>
        </div> 
        </div>
      </div>
      
       <section className="" style={{ background: "#e2f6ff 0% 0% no-repeat padding-box", opacity: "1" }}>
      {/* <div className="container p-3">

         
          <NewStudentForm />
       
      </div> */}
      </section>
   {/* <div className="container mt-4 mb-5" style={{ color: "#d9534f", fontSize: "1.5rem", textAlign:"center" }}>Registration Closed</div> */}
    {/* <NewStudentForm /> */}

    <div className="container text-center pt-4 mb-5">
        <div className="row g-4">
            <Link href="/hallticket">
            <button className={styles.normalbutton}>
                Download Hall Ticket
            </button>
            </Link>
        </div>
    </div>

    <div className="container text-center pt-4 mb-5" style={{ background: "#F4F6F8" }}>
        <div className="row pt-2">
            <div className="mb-4 col-md-6 " style={{ fontSize: "14px", textAlign: "justify" }}>
            <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "18px",  }}>Instructions to Offline students :</span> </p>
            <p>Dear Offline Students, Kindly bring the Hard copy of <br/> GR IIA Mains and Shankar Hall Ticket without Fail</p>
            <p className=" mb-4 col-md-6"> <b>Enquiry : +91 9360816977</b></p>
            </div>
            

            <div className="mb-4 col-md-6 " style={{ fontSize: "14px", textAlign: "justify" }}>
            <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "18px",  }}>Instructions to online students only :</span> </p>
            <p>We have arranged a Demo Test (For Trial which consists of 25 Qns) for Online Mode Registration of GR IIA MAINS STATE LEVEL MOCK TEST in the Shankar IAS Academy’s Test Press Portal:</p>
            <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "14px",  }}> NON SHANKAR STUDENTS : </span> can access the demo test</p>
        
            <p><b>Test Press Portal : </b><a href="https://shankariastnpsctestbatch.testpress.in/" target="_blank" rel="noopener noreferrer" >https://shankariastnpsctestbatch.testpress.in/</a></p>
            <p><b>Username : </b>Your Mobile No</p>
            <p><b>Password : </b>Your Mobile No</p>
            <p><span className=" mb-4 col-md-6" style={{ color: "#db1913ff", fontSize: "14px",  }}> SHANKAR STUDENTS : </span> Use your SIAAN ID Provided in the Institute.</p>
            </div>
        </div>
    </div>

    {/* <div className="container text-center mb-5">
        <div className="row g-4 pt-2">
            <div className="" >
                <Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GrpI-Mains-Mocktest/GRP1-Mains-Mocktest-Online-Std-Instructions.pdf"
                 target="_blank"  
                >  
                   <span style={{ color: "#db1913ff", fontSize: "19px", textAlign:"center" }}>Download Online Students Instructions  <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></span>
                </Link>

            </div>

            <div className="">
                <Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GrpI-Mains-Mocktest/GRP1-Mains-Mocktest-Offline-Std-Instructions.pdf" target="_blank" rel="noopener noreferrer">
                   <span style={{ color: "#db1913ff", fontSize: "19px", textAlign:"center" }}>Download Offline Students Instructions<Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/></span>
                </Link>
            </div>
        </div>
    </div> */}

    <section className='pt-5' style={{ background: "#F4F6F8" }}>
        <div className="container">
            <h2 className={`${styles.contactheader} text-center`}> TNPSC Group II/IIA Mains State Level Mock Test 2026 – Schedule</h2>
            
            
            <h3 className={`${styles.contactheader} text-center`}>Mock Test Schedule for Group IIA Mains</h3>
            <div className="row g-4 justify-content-center">
                {[
                    {
                    date: "01st February 2026",
                    paper: "Paper-I (Tamil Eligibility Test)",
                    TypeofExamination: "Descriptive",
                    reporttime: "Reporting Time : 01:30 PM",
                    time: "2:00 PM – 05:00 PM",
                    icon: "/images/icon/Calender-01.png",
                    },
                    {
                    date: "01st February 2026",
                    paper: "Paper-II (General Studies, General Intelligence and Reasoning)",
                    TypeofExamination: "Objective(OMR method)",
                    reporttime: "Reporting Time : 8:00 AM",
                    time: "9:30 AM – 12:30 PM",
                    icon: "/images/icon/Calender-01.png",
                    },
                  
                ].map((item, i) => (
                    <div key={i} className="col-12 col-md-6 col-xl-4">
                    <div
                        className="card h-100 border-0 rounded-4 shadow-lg hover-shadow  transition-all"
                        style={{
                        background: "linear-gradient(180deg, #ffffff, #f9f9ff)",
                        padding: "25px 20px",
                        }}
                    >
                        <div className="card-body text-center d-flex flex-column justify-content-between">
                        <div>
                            <div className="mb-4">
                            <Image
                                src={item.icon}
                                alt="calendar"
                                width={60}
                                height={60}
                                className="img-fluid"
                            />
                            </div>
                            <h5 className="fw-bold text-dark mb-2">{item.date}</h5>
                            <p
                            className="fw-semibold text-secondary mb-2"
                            style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                            >
                            {item.paper}
                            </p>
                            <p
                            className="fw-semibold mb-3"
                            style={{ color: "#d9534f", fontSize: "0.95rem" }}
                            >
                            {item.reporttime}
                            </p>
                            <p>Type of Examination</p>
                             <p
                            className="fw-semibold mb-3"
                            style={{ color: "#d9534f", fontSize: "0.95rem" }}
                            >
                            {item.TypeofExamination}
                            </p>
                        </div>

                        <div>
                            <span
                            className="badge text-white px-4 py-3 rounded-pill"
                            style={{
                                background:
                                "linear-gradient(90deg, #007bff, #004aad)",
                                fontSize: "1rem",
                                letterSpacing: "0.6px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                            }}
                            >
                            {item.time}
                            </span>
                        </div>
                        </div>
                    </div>
                    </div>
                ))}
            </div>
             
        </div>
    </section>
    
    <section className='pt-2' style={{ background: "#F4F6F8" }}>
        <div className="container">
            <h3 className={`${styles.contactheader} text-center pt-2`}>Mock Test Schedule for Group II Mains</h3>
            <div className="row g-4 justify-content-center">
                {[
                    {
                    date: "01st February 2026",
                    paper: "Paper-I (Tamil Eligibility Test)",
                     TypeofExamination: "Descriptive",
                    reporttime: "Reporting Time : 1:30 PM",
                    time: "2:00 PM – 05:00 PM",
                    icon: "/images/icon/Calender-01.png",
                    },
                    {
                    date: "15th February 2026",
                    paper: "Paper-II (General Studies)",
                    TypeofExamination: "Descriptive",
                    reporttime: "Reporting Time : 8:00 AM",
                    time: "9:30 AM – 12:30 PM",
                    icon: "/images/icon/Calender-01.png",
                    },
                  
                ].map((item, i) => (
                    <div key={i} className="col-12 col-md-6 col-xl-4">
                    <div
                        className="card h-100 border-0 rounded-4 shadow-lg hover-shadow  transition-all"
                        style={{
                        background: "linear-gradient(180deg, #ffffff, #f9f9ff)",
                        padding: "25px 20px",
                        }}
                    >
                        <div className="card-body text-center d-flex flex-column justify-content-between">
                        <div>
                            <div className="mb-4">
                            <Image
                                src={item.icon}
                                alt="calendar"
                                width={60}
                                height={60}
                                className="img-fluid"
                            />
                            </div>
                            <h5 className="fw-bold text-dark mb-2">{item.date}</h5>
                            <p
                            className="fw-semibold text-secondary mb-2"
                            style={{ fontSize: "0.95rem", lineHeight: "1.4" }}
                            >
                            {item.paper}
                            </p>
                            <p
                            className="fw-semibold mb-3"
                            style={{ color: "#d9534f", fontSize: "0.95rem" }}
                            >
                            {item.reporttime}
                            </p>
                            <p>Type of Examination</p>
                             <p
                            className="fw-semibold mb-3"
                            style={{ color: "#d9534f", fontSize: "0.95rem" }}
                            >
                            {item.TypeofExamination}
                            </p>
                        </div>

                        <div>
                            <span
                            className="badge text-white px-4 py-3 rounded-pill"
                            style={{
                                background:
                                "linear-gradient(90deg, #007bff, #004aad)",
                                fontSize: "1rem",
                                letterSpacing: "0.6px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                            }}
                            >
                            {item.time}
                            </span>
                        </div>
                        </div>
                    </div>
                    </div>
                ))}
            </div>

        </div>
    </section>
     
    

   <div className="container-fluid p-0" style={{ background: "#F9FAFB" }}>
        {/*<section className="py-2">
            <div className="container">
                <h2 className={`${styles.contactheader} text-center `}>Mode of Examination</h2>
                <div className="row justify-content-center ">
                    <div className="col-10 col-md-6">
                    <div className="p-4 rounded-4 shadow-sm bg-white">
                        <h4 className=" text-center">Both <span className="text-success">Offline</span> and <span className="text-success">Online</span></h4>
                        <p className="text-muted mt-2 mb-0">Choose your preferred mode and experience the real TNPSC Mains environment.</p>
                    </div>
                    </div>
                </div>
            </div>
        </section>*/}
    <section className="py-5" style={{ background: "#F9FAFB" }}>
        <div className="container">
                <div className="row">
                    <div className="card h-100 border-0 rounded-4 shadow-lg hover-shadow  transition-all"
                        style={{background: "linear-gradient(180deg, #ffffff, #f9f9ff)", padding: "25px 20px",}}>
                        <p className='col-12 col-md-12  p-2'>All the mock registered candidates need to bring <span style={{color:"#053281"}}> SIA Mock Test Hall Ticket (Hard Copy)</span> and <span style={{color:"#a7000c"}}>TNPSC Group II or Group IIA Prelims or Mains Hall Ticket 2025(Hard Copy)</span> and submit them at the respective exam venue. After due verification of your hall tickets, you will be allowed to enter the exam venue.</p>   
                    </div>
                </div>
        </div>

        <div className="container py-4">
            <div className="row g-4">
                <div className="col-12 col-md-6">
                    <div className="p-4 card h-100 border-0 rounded-4   transition-all"
                        style={{background: "linear-gradient(180deg, #b5daff, #f9f9ff)"}} >
                        <h2 className={`${styles.contactheader} text-center mb-4`}>
                        Important Dates – Group IIA Mains
                        </h2>
                        <ul className="list-unstyled mb-0">
                        <li className="mb-2">
                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <strong>Registration Closing:</strong> 28th Jan 2026
                        </li>
                        <li className="mb-2">
                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <strong>Hall Ticket Download:</strong> 29th Jan 2026 – 5:00 PM
                        </li>
                        <li>
                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <strong>Mock Test Results:</strong> 2nd Feb 2026 – 6:00 PM
                        </li>
                        </ul>
                    </div>
                </div>

                <div className="col-12 col-md-6">
                    <div className="p-4 card h-100 border-0 rounded-4 transition-all" style={{background: "linear-gradient(180deg, #b5daff, #f9f9ff)"}} >
                        <h2 className={`${styles.contactheader} text-center mb-4`}>
                        Important Dates – Group II Mains
                        </h2>
                        <ul className="list-unstyled mb-0">
                        <li className="mb-2">
                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <strong>Registration Closing:</strong> 28th Jan 2026
                        </li>
                        <li className="mb-2">
                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <strong>Hall Ticket Download:</strong> 29th Jan 2026 – 5:00 PM
                        </li>
                        <li>
                        <i className="bi bi-check-circle-fill text-danger me-2"></i> <strong>Mock Test Results:</strong> 17th Feb 2026 – 6:00 PM
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section className="py-5" style={{ background: "#E9EEF3" }}>
      <div className="container">
            <h2 className={`${styles.contactheader}  mb-2`}>Features of the Mock Test</h2>
            <div className="row ">
                <div className="col-12 col-md-10 col-lg-8">
                <ul className="list-group list-group-flush bg-transparent">
                    {[
                    "Real Simulation of TNPSC Group IIA Main Written Examination conducted by TNPSC",
                    "Reflection making Mock Test",
                    "Release of Rank list",
                   
                    ].map((text, i) => (
                    <li key={i} className="list-group-item bg-transparent border-0 fs-5 py-2">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>{text}
                    </li>
                    ))}
                </ul>
                </div>
            </div>
            <div className="alert alert-warning mt-4" role="alert">
                <h5 className="fw-bold text-dark mb-2">Note<sup className= {`${styles.dot}`}>*</sup></h5>
                <p className="mb-0">
                     Written Answer Scripts will not be given/shared to students for any reason after evaluation and our evaluation is final.
                </p>
            </div>
      </div>     
    </section>
    </div>

     <section className="pt-md-3 pt-lg-4" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
          <div className="container"> 
              <div className={`${styles.head}  pt-2 pb-2`}>
                <h3>TNPSC Group II/IIA Mains State Level Mock Test - Venue</h3>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4 col-12 mb-3">
                  <div className={`${styles.contactbox} h-100 `}>
                    <div className="row pt-3 pb-3">
                          <div className= {`${styles.addbox} px-4 pt-2`}>
                              <span>Shankar IAS Academy, Admission Office</span>
                              <p >Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040. <br/>Contact: 76677 66266</p>
                         </div>

                        
                    </div>
                 </div>
               </div>

               <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Shankar IAS Academy (Celestial Place)</span>
                                  <p>No. 255 , AL Block , 4th Avenue, <br/> Shanthi colony, Anna Nagar, <br/> Chennai - 600 040.<br/>Contact: 044-43533445 | 044-45543082</p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Chennai - ADYAR </span>
                                  <p >SHANKAR IAS ACADEMY , No-2/23, 3rd Cross Street, Padmanabhanagar, (Opposite to Sishya School), Adyar,  Chennai-600 020 <br/> Contact: 90252 78278, 9962145999</p>
                              </div>
                          </div>
                    </div>
                </div>

                  <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Namakkal</span>
                                <p>Shankar IAS Academy, Cheran Towers, Block No. 2/67, 1st floor West Thillaipuram Main Road, Paramathi Rd, Namakkal 637 001 <br/>Contact: 99944 34921  |  04286-223007</p>
                              </div>
                          </div>
                    </div>
                </div>

                 <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                              <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Salem</span>
                                <p>Shankar IAS Academy, NO.207/5, United Arcade, Kavery Avenue, State Bank Colony, <br/>Salem 636004.<br/>
                                  Contact: 0427-2441961 / 8940080039</p>
                              </div>
                          </div>
                       </div>
                </div>

                  <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Trichy</span>
                                <p>Shankar IAS Academy, N.R.Towers, A9 (N),  Salai Road,  Thillai Nagar, Trichy-620018.
                                  Landmark: LIC -Rock Fort Branch Building <br/>
                                  Contact : 97896 64555 / 0431-4976911</p>  
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Madurai</span>
                                <p>Shankar IAS Academy, Plot no:409 ,  <br/>2nd Floor, B Mall super market, Church Road, <br/> Madurai, Tamil Nadu 625020<br/>
                                    Contact: 97896-22555</p>
                              </div>
                          </div>
                    </div>
                </div>

                 <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Thiruvarur</span>
                                  <p>Shankar IAS Academy, 3/310/7 GTN Complex, Mannai salai, (Opp to State Bank of India), Vilamal,<br/> Thiruvarur-610 001. <br/>
                                   Contact: 97877 34943 | 70102 62725 | 9787734943</p>
                              </div>
                          </div>
                    </div>
                </div>


                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Coimbatore.</span>
                                <p> 790, Cross Cut Rd, TNPSC, <br/> Gandhipuram,Tamil Nadu - 64101 <br/>
                                  Contact: 9994551898</p>  
                              </div>
                          </div>
                    </div>
                </div>


                {/* <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Cuddalore</span>
                                  <p >St. Antony's  Matriculation  Higher  secondary School , ECR Main  Road , Chinnakanganakuppam, <br/> Cuddalore - 607006</p>
                              </div>
                          </div>
                    </div>
                </div> 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Vellore</span>
                                  <p > Desia Matriculation  Higher Secondary School, Virupatchipuram, Vellore -632002 </p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Kancheepuram</span>
                                  <p >Thirumalai Engineering College, Krishnapuram Post , Kilambi, Kanchipuram - 631551</p>
                              </div>
                          </div>
                    </div>
                </div>

                 <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Krishnagiri</span>
                                  <p>Nalanda Matriculation Hr. Sec School, Salem Bye Pass Road , Adjacent to Dairy Campus Krishnagiri -635001</p>
                              </div>
                          </div>
                    </div>
                </div> 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Erode</span>
                                  <p>V.V.C.R.Murugesanar Sengunthar  Girls Higher Secondary School, Thillai Nagar , Erode - 638001</p>
                              </div>
                          </div>
                    </div>
                </div>  

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Tirunelveli</span>
                                  <p>MDT Hindu School, Tirunelveli Junction, Tirunelveli</p>
                              </div>
                          </div>
                    </div>
                </div>

               
                </div> */}

              </div>
          </div>
        <br/>
        </section>


    <Footer />

    </>
  );
}




